export enum ErrorTemplateToken {
  SignupSupportButton = '%signup-support-button%',
  FraudSupportButton = '%fraud-support-button%',
}

export const errorTemplateTokenSet = new Set(Object.values(ErrorTemplateToken));
